var AdyenPayment = (function ($) {

    function init() {

        $("input[type='radio'][name='adyenPaymentType']").each(function () {
            if (!$(this).val()) {
                $(this).val($(this).attr("id"));
            }
        });

        var isAdyenFailurePayment = $('input[name="isAdyenFailurePayment"]').val();
        if (isAdyenFailurePayment === 'true') {
            $('.payment-cancelled-notice').removeClass('hide');
        }

        $("#adyen").change(function() {
            if (this.checked) {
                if ($('#additionaladyen').find('input[type="radio"]').length === 1) {
                    $('#additionaladyen').find('input[type="radio"]').prop('checked', true).trigger("change");
                }
            }
        });

        $('input[name="adyenPaymentType"]').change(function() {
            $('.additionalAdyenTypes').hide();
            if (this.checked) {
                $(this).closest('div').next('.additionalAdyenTypes').show();

            }
        });

    }

    return {
        init: init
    };
})($);

$(function () {
    AdyenPayment.init();
});